import { createRouter, createWebHistory } from 'vue-router';
import Page from '../Pages/Page.vue';

// Detect if we're in a subdirectory (e.g., /brochure)
const base = window.location.pathname.startsWith('/brochure') ? '/brochure' : '';

const routes = [
  {
    path: '/pages/:slug',
    name: 'page',
    component: Page
  },
  {
    path: '/',
    redirect: '/pages/1'
  },
  {
    // Catch-all 404 - redirect to first page
    path: '/:pathMatch(.*)*',
    redirect: '/pages/1'
  }
];

const router = createRouter({
  history: createWebHistory(base),
  routes
});

export default router;
